import { render, staticRenderFns } from "./StarRatingCard.vue?vue&type=template&id=2051b28e&"
import script from "./StarRatingCard.vue?vue&type=script&lang=js&"
export * from "./StarRatingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports